/**
 * Helpers for mobile menu date chips / grouped pending lists.
 */

const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export function parseSignDate(sign) {
  if (sign == null) return null;
  if (typeof sign.created === 'number' && !Number.isNaN(sign.created)) {
    return new Date(sign.created);
  }
  if (sign.date) {
    const raw = String(sign.date).trim();
    // MM/DD/YYYY
    const mdy = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (mdy) {
      return new Date(Number(mdy[3]), Number(mdy[1]) - 1, Number(mdy[2]));
    }
    // YYYY-MM-DD
    const ymd = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (ymd) {
      return new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
    }
    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }
  return null;
}

export function dayKey(date) {
  if (!date || Number.isNaN(date.getTime())) return 'unknown';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function dayLabel(date) {
  if (!date || Number.isNaN(date.getTime())) return 'Unknown';
  const now = new Date();
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startThat = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round((startToday - startThat) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays > 1 && diffDays < 7) return WEEKDAYS[date.getDay()];
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${mm}/${dd}/${date.getFullYear()}`;
}

export function formatSentDate(sign) {
  const d = parseSignDate(sign);
  if (!d) return sign?.date || '';
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${mm}/${dd}/${d.getFullYear()}`;
}

/**
 * @returns {{ key: string, label: string, items: any[] }[]}
 */
export function groupSignsByDay(signs) {
  const map = new Map();
  for (const sign of signs || []) {
    const d = parseSignDate(sign);
    const key = dayKey(d);
    const label = dayLabel(d);
    if (!map.has(key)) {
      map.set(key, { key, label, items: [], sort: d ? d.getTime() : 0 });
    }
    map.get(key).items.push(sign);
  }
  return [...map.values()].sort((a, b) => b.sort - a.sort);
}
